import Marquee from "react-fast-marquee";
import { motion } from "framer-motion";

const ROW_ONE = [
  "The Drew Barrymore Show", "Goop", "Elle", "Yahoo!", "Shoutout LA", "Barstool Sports",
  "The Hollywood Reporter", "Fashion Magazine", "Montecristo Magazine", "Publishers Weekly",
  "Goodreads", "Best Self Magazine", "Medium", "Well Damn", "Language of Love with Dr. Laura Berman",
  "Magic Hour with Anita Moorjani", "Gaia — Beyond Belief", "Acid for Squares",
  "Stream of Consciousness with Torrey DeVitto", "The Zest", "Coast to Coast Radio",
  "The Art of Being Well with Dr. Will Cole", "Impact the World with Lee Harris",
  "The Michelle Chalfant Show", "So She Slays", "Next Level Soul", "Passion Struck with John Miles",
  "Oldish with Tori & Randy Spelling", "The Hannah Fletcher Show", "Mystic Mag", "James Van Praagh",
  "Soulmate Twin Flame", "Eric's House", "Orange Appeal", "The Magazine Plus",
  "Famous Psychic Mediums", "Looking to the Stars", "Celeb Magnet", "Vancouver Sun",
  "All American Speakers", "OM Times", "Everand", "Just Breathe Magazine",
  "Canvas Rebel Magazine", "Look Within Magazine", "Human Shift", "Elevates Society",
  "Get Griefy Magazine", "She Who Heals",
];

const ROW_TWO = [
  "The Conscious Healing Podcast", "Excuse Me Podcast with Vickie Guerrero", "All On Perspective Show",
  "Life Continuing Podcast", "Spiritual Rebels and Misfits", "Spiritual Spiral", "Zodiac Magic Podcast",
  "Near Death Experiences and the Afterlife", "Elevated Planet Web Show", "Spiritual Biz Podcast",
  "Intentional Living Podcast", "Life, Death and the Space Between", "Sense of Soul Podcast",
  "The Everygirl Podcast", "Life After Life NDE Channel", "Aware Now", "Hakavati Show",
  "Synergy India Show", "In My Heart Podcast", "The Soul Frequency Show",
  "Balance, Beautiful, Abundant Show", "High Energy Health Soul", "Soul Slumber Party",
  "High Vibin It Podcast", "How I Made It Through", "Just Ask Spirit Podcast",
  "Inner Worlds — Ethereal Edge", "Dream Your Life", "Elevated Conversations", "Talk Spirit to Me",
  "Anita Moorjani Live", "These Fukken Feelings", "Ethereal Encounters Unveiled",
  "Bold and Beautiful with Rebecca Whitman", "The Enlighten Up Podcast", "Adam Gell Podcast",
  "Harmony Health & Heather", "The Aware Show with Lisa Garr", "Your Superior Self",
  "Women Awakening Podcast",
];

const ROW_THREE = [
  "Amy Robbins Podcast", "Tia Renee Podcast", "Elevated Planet", "Inner Power Insights",
  "Ask Julie Ryan", "Seeking Center", "Carefree and Conscious", "The Sheol Podcast",
  "Wishbeads Podcast", "Jeff Mara Podcast", "Lara and Lou Podcast", "Soul Inspired Podcast",
  "The Other Side", "Reiki Radio", "Spiraling Higher Podcast",
  "The Healthy Doc Podcast with Dr. Nigma Talib", "The Messages From Beyond",
  "Grief Is A Sneaky Bitch", "Fear Unzipped", "Our Paranormal Afterlife", "Laurie Majka on YouTube",
  "The Catherine Plano Podcast", "Outer Limits of Inner Truth", "Stellar Life with Orion Talmay",
  "Uncover Your Magic", "The Other Side NDE", "Life & Beyond", "Beauty & the Babble",
  "Darkness Radio", "Great Ones with Susie Abromeit", "Love Covered Life with Melissa Denyce",
  "Tapping In", "The Wisdom of Jacob's Ladder", "Explore the Extraordinary", "Hopenning 2.0",
  "Transformation to Expansion with Lajoie Bradley", "Dare to Be Strong", "Soul Connected Podcast",
  "The Spirit Mirror with Jen Abra", "The Jay Scherick Podcast",
];

const ROWS = [
  { items: ROW_ONE, speed: 42, direction: "left" },
  { items: ROW_TWO, speed: 36, direction: "right" },
  { items: ROW_THREE, speed: 40, direction: "left" },
];

function IndexRow({ items, speed, direction, rowIndex }) {
  return (
    <Marquee speed={speed} direction={direction} gradient={false} pauseOnHover data-testid={`media-index-row-${rowIndex}`}>
      {items.map((name, i) => (
        <div key={name} className="mx-8 flex items-center gap-8 md:mx-10 md:gap-10">
          <span
            className={
              (i + rowIndex) % 2
                ? "whitespace-nowrap font-display text-lg font-light italic text-[#6B5D4F]/80 md:text-xl"
                : "whitespace-nowrap font-body text-[0.7rem] font-medium uppercase tracking-[0.3em] text-[#6B5D4F]/85 md:text-xs"
            }
          >
            {name}
          </span>
          <span className="h-1.5 w-1.5 shrink-0 rotate-45 bg-[#C5A059]" aria-hidden="true" />
        </div>
      ))}
    </Marquee>
  );
}

export default function MediaIndex() {
  return (
    <section data-testid="media-index-section" className="overflow-hidden border-y border-[#6B5D4F]/10 bg-[#FDFAF4] py-24 lg:py-32">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
        className="mx-auto mb-16 flex max-w-7xl flex-col items-center gap-6 px-6 text-center lg:px-10"
      >
        <p className="font-body text-[0.65rem] font-medium uppercase tracking-[0.5em] text-[#C5A059]">
          The Complete Index
        </p>
        <h2 className="max-w-4xl font-display text-4xl font-light leading-tight tracking-tighter text-[#6B5D4F] sm:text-5xl">
          One voice. <span className="italic text-[#C5A059]">Thousands of conversations</span> — and counting.
        </h2>
        <p className="max-w-2xl font-body text-base font-light leading-relaxed text-[#8B7D6B]">
          Every show, podcast, publication, and platform that has featured Susan&rsquo;s work — a living
          archive that grows every single month.
        </p>
      </motion.div>

      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1, delay: 0.15 }}
        className="space-y-8"
      >
        {ROWS.map((r, i) => (
          <IndexRow key={i} rowIndex={i} items={r.items} speed={r.speed} direction={r.direction} />
        ))}
      </motion.div>
    </section>
  );
}
